import React, {Component} from 'react';
import RouteStageContextProvider from "./context/RouteStageContext";
import CapabilityContextProvider from "../global/context/CapabilityContext";
import StageFilterContextProvider from "./context/StageFilterContext";
import StageView from "./StageView";
import AssociateContextProvider from "../associate/context/AssociateContextProvider";
import DWPFileContextProvider from "../fileupload/context/DWPUploadContext";

class Stage extends Component {
    render() {
        return (
            <CapabilityContextProvider>
                <StageFilterContextProvider context={this.props.match.params.context}>
                    <RouteStageContextProvider>
                        <DWPFileContextProvider>
                        <AssociateContextProvider>
                        <StageView history={this.props.history}/>
                        </AssociateContextProvider>
                        </DWPFileContextProvider>
                    </RouteStageContextProvider>
                </StageFilterContextProvider>
            </CapabilityContextProvider>
        )
    }
}

export default Stage;



// WEBPACK FOOTER //
// ./src/components/stageStatus/Stage.js